import * as PDFObject from 'pdfobject';
import PropTypes from 'prop-types';
import fetchFileMetadata from './actions';

const defaultOptions = {
  forcePDFJS: true,
  PDFJS_URL: `${window.appContext}/res/components/pdfjs/web/viewer.html`,
};

export default class Preview extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      initiated: false,
      mimetype: null,
      update: false,
    };
  }

  static defaultProps = {
    active: true,
    id: 'documentPreview',
    index: 0,
    options: {},
  };

  static propTypes = {
    active: PropTypes.bool,
    fileName: PropTypes.string,
    fetchFile: PropTypes.func,
    id: PropTypes.string,
    index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    mimetype: PropTypes.string,
    nodeRef: PropTypes.string,
    objectURL: PropTypes.string,
    options: PropTypes.object,
  };

  componentDidMount() {
    const { nodeRef, fetchFile, index, id, objectURL } = this.props;
    if (nodeRef) {
      if (fetchFile) {
        fetchFileMetadata(nodeRef);
        return;
      }

      fetchFileMetadata(nodeRef)
        .then(response => {
          this.setState({
            mimetype: response.mimetype,
          });
        })
        .catch(() => {
          this.setState({
            error: true,
          });
        });
    } else if (objectURL) {
      const options = {
        ...defaultOptions,
        ...this.props.options,
      };
      PDFObject.embed(objectURL, `#com.onlio.edocat.base:edocatBaseShare:jar:3.3.374-SNAPSHOT-${index}`, options);
    }
  }

  componentDidUpdate() {
    const mimetype = this.state.mimetype || this.props.mimetype;
    if (!this.state.initiated && this.props.active && mimetype) {
      this.setState({ initiated: true });
      const { nodeRef, index, id } = this.props;
      const fileName = this.getFileName();
      const options = {
        ...defaultOptions,
        ...this.props.options,
      };

      if (mimetype === 'application/pdf') {
        PDFObject.embed(
          `${window.appContext}/proxy/alfresco/api/node/${nodeRef.replace(':/', '')}/content;cm:content${
            fileName ? `?saveName=${fileName}` : ''
          }`,
          `#com.onlio.edocat.base:edocatBaseShare:jar:3.3.374-SNAPSHOT-${index}`,
          options
        );
      } else if (mimetype.includes('image/')) {
        // images are solved in render
      } else {
        fetch(
          `${window.appContext}/proxy/alfresco/api/node/${nodeRef.replace(':/', '')}/content/thumbnails/pdf?c=force${
            fileName ? `&saveName=${fileName}` : ''
          }`,
          { credentials: 'same-origin' }
        )
          .then(response => {
            if (response.status !== 200) {
              this.setState({
                error: true,
              });
            }
            PDFObject.embed(
              `${window.appContext}/proxy/alfresco/api/node/${nodeRef.replace(
                ':/',
                ''
              )}/content/thumbnails/pdf?c=force${fileName ? `&saveName=${fileName}` : ''}`,
              `#com.onlio.edocat.base:edocatBaseShare:jar:3.3.374-SNAPSHOT-${index}`,
              options
            );
          })
          .catch(err => {
            this.setState({
              error: true,
            });
            throw err;
          });
      }
    }
  }

  getFileName = () => {
    const { fileName } = this.props;
    if (!fileName) return '';

    return fileName.endsWith('.pdf') ? encodeURIComponent(fileName) : `${encodeURIComponent(fileName)}.pdf`;
  };

  render() {
    const { active, id, index, nodeRef, className } = this.props;
    const mimetype = this.state.mimetype || this.props.mimetype;
    return (
      <div className="Edocat-Document-Preview">
        <div className={`error-message hidden__${active ? !this.state.error : 'true'}`}>
          <p>{window.Alfresco.messages.global['docPreview.errors.defaultText']}</p>
        </div>
        <div
          id={`com.onlio.edocat.base:edocatBaseShare:jar:3.3.374-SNAPSHOT-${index}`}
          className={`${active ? 'visible' : 'hidden'}${
            className ? ' Document-Preview ' + className : ' Document-Preview'
          }${` hidden__${this.state.error}`}`}
          key={index}
        >
          {this.state.initiated && !this.state.error && mimetype && mimetype.includes('image/') && (
            <img
              className="Preview-Image"
              src={`${window.appContext}/proxy/alfresco/api/node/${nodeRef.replace(':/', '')}/content;cm:content`}
            />
          )}
          {!this.state.error && mimetype && !mimetype.includes('image/') && (
            <div className="React-Loading--container">
              <div className="React-Loading" />
            </div>
          )}
        </div>
      </div>
    );
  }
}
